/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Button, Flex, Text, useDisclosure } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { useFormValidationToast } from '../../../../services/actionToast';
import { InputForm } from '../../../inputs/forms/InputForm';
import { FormButton } from '../../../buttons/FormButton';
import { ReturnButton } from '../../../buttons/ReturnButton';
import { getFetchData, useFetch } from '../../../../hooks/useFetch';
import AlertModal from '../../../AlertModal';
import { PageTitle } from '../../../PageTitle';
import { FormBox } from '../../../formBox';
import { FormHeading } from '../../../formHeading';
import { DateInputForm } from '../../../inputs/forms/DateInputForm';
import { CustomParentsInputForm } from '../../../inputs/forms/CustomParentsInputForm';
import { getFormattedLabel } from '../../../../utils/FormatFunctions';
import { SelectInputForm } from '../../../inputs/forms/SelectInputForm';

interface StudentFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: any;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function NewForm({ defaultValues = {} }: StudentFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/children';
  const { requestApi, error } = useFetch(baseUrl, { actionFeedback: false });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { itemId } = useParams();
  const navigate = useNavigate();
  const {
    requestApi: reqApiInstitutions,
    data: dataInstitutions,
    loading: loadingInstitutions,
  } = useFetch('/v1/admin/institutions');
  const {
    requestApi: reqApiTeams,
    data: dataTeams,
    loading: loadingTeams,
  } = useFetch('/v1/admin/teams');
  const { data: optionsTeams, pagination: paginationTeams } = getFetchData(dataTeams);
  const { data: optionsInstitutions, pagination: paginationInstitutions } =
    getFetchData(dataInstitutions);

  const optionsKinship = [
    {
      label: 'Pai',
      value: 'PAI',
    },
    {
      label: 'Mãe',
      value: 'MAE',
    },
    {
      label: 'Tio',
      value: 'TIO',
    },
    {
      label: 'Tia',
      value: 'TIA',
    },
    {
      label: 'Avô(ó)',
      value: 'AVO',
    },
    {
      label: 'Outro',
      value: 'OUTRO',
    },
  ];

  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'name',
      value: defaultValues.name ?? '',
      placeholder: 'Nome do aluno',
      label: 'Nome',
      yup: Yup.string().required('Este campo é obrigatório!'),
    },
    {
      name: 'birth_date',
      value: defaultValues.birth_date ? (moment(defaultValues.birth_date).toDate() as any) : null,
      placeholder: '00/00/0000',
      label: 'Data de nascimento',
      yup: Yup.string().nullable().required('Este campo é obrigatório!'),
    },
    {
      name: 'parents',
      value: [
        ...(defaultValues?.parents?.map((item) => ({
          ...item,
          kinship: optionsKinship.find((kinship) => kinship.value === item.kinship),
        })) ?? []),
      ],
      placeholder: 'Responsáveis do aluno',
      label: 'Responsáveis',
      yup: Yup.array()
        .of(
          Yup.object().shape({
            name: Yup.string().required('Este campo é obrigatório!'),
            email: Yup.string().email('Email inválido').required('Este campo é obrigatório!'),
            cell_phone: Yup.string().required('Este campo é obrigatório!'),
            kinship: Yup.mixed().required('Este campo é obrigatório!'),
          })
        )
        .min(1, 'É necessário informar pelo menos 1 responsável do aluno!'),
    },
    {
      name: 'team_id',
      value: defaultValues?.team ? getFormattedLabel(defaultValues?.team) : null,
      placeholder: 'Selecione uma Turma',
      label: 'Turmas',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'teacher',
      value: defaultValues?.team ? getFormattedLabel(defaultValues?.team) : null,
      placeholder: 'Professor',
      label: 'Professor',
      yup: Yup.mixed(),
    },
    {
      name: 'institution',
      value: defaultValues?.team?.institution
        ? getFormattedLabel(defaultValues?.team?.institution)
        : null,
      placeholder: 'Instituição',
      label: 'Instituição',
      yup: Yup.mixed().required('Este campo é obrigatório!'),
    },
    {
      name: 'class_student',
      value: defaultValues?.team ? getFormattedLabel(defaultValues?.team) : null,
      placeholder: 'Turma',
      label: 'Turma',
      yup: Yup.mixed(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const name = formInputs.find((field) => field.name === 'name');
  const birthDate = formInputs.find((field) => field.name === 'birth_date');
  const parents = formInputs.find((field) => field.name === 'parents');
  const team = formInputs.find((field) => field.name === 'team_id');
  const teacher = formInputs.find((field) => field.name === 'teacher');
  const institution = formInputs.find((field) => field.name === 'institution');
  const classStudent = formInputs.find((field) => field.name === 'class_student');

  const onSubmit = async (values: any) => {
    const params = {
      ...values,
      team_id: values.team_id.value,
      birth_date: values.birth_date ? moment(values.birth_date).format('yyyy-MM-DD') : null,
      parents: [
        ...(values.parents.map((parentItem) => ({
          name: parentItem.name,
          email: parentItem.email,
          cell_phone: parentItem.cell_phone,
          kinship: parentItem.kinship.value,
        })) ?? []),
      ],
    };
    await requestApi(
      defaultValues.name ? 'put' : 'post',
      params,
      defaultValues.name ? `${baseUrl}/${itemId}` : null
    );
    onOpen();
  };

  useEffect(() => {
    if (defaultValues.name) {
      reset(defaultValuesSchema);
    }
  }, [defaultValues]);
  useEffect(() => {
    reqApiTeams('get');
  }, []);

  useEffect(() => {
    const selectedTeam = watch('team_id')?.label;
    const selectedOption = optionsTeams?.find((item) => item.name === selectedTeam);
    if (selectedOption) {
      setValue('teacher', selectedOption?.teacher?.name);
      setValue('class_student', selectedOption?.school_class?.name);
    }
  }, [watch('team_id'), optionsInstitutions]);

  return (
    <FormBox>
      <Flex>
        <ReturnButton previousPage="students" mb={5} />
        <PageTitle>{defaultValues.name ? 'Editar' : 'Criar'} Aluno</PageTitle>
      </Flex>

      <AlertModal
        alertMsg={
          <Text textAlign="center" fontWeight="bold" fontSize="25px">
            {!error
              ? `Aluno ${defaultValues.name ? 'editado' : 'criado'} com sucesso!`
              : error?.msg}
          </Text>
        }
        msgStatus={error ? 'error' : 'success'}
        closeOnOverlayClick={!!error}
        useSecondaryActions
        isOpenSecondary={isOpen}
        onCloseSecondary={onClose}
        ConfirmButton={
          <Button
            w="250px"
            boxShadow="0px 5px 10px #00000065"
            borderRadius="full"
            onClick={() => navigate('/students')}
          >
            Retornar para a listagem
          </Button>
        }
      />

      <form noValidate onSubmit={handleSubmit(onSubmit, validationToast)}>
        <FormHeading>Informações Básicas</FormHeading>
        <Flex gap={5}>
          <Box flex={1}>
            <InputForm
              name={name?.name}
              label={name?.label}
              placeholder={name?.placeholder}
              isRequired
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <DateInputForm
              name={birthDate?.name}
              label={birthDate?.label}
              placeholderText={birthDate?.placeholder}
              isRequired
              minDate={null}
              maxDate={new Date()}
              control={control}
              errors={errors}
            />
          </Box>
        </Flex>
        <Box flex={1}>
          <SelectInputForm
            name={institution?.name}
            label={institution?.label}
            options={[...(optionsInstitutions?.map((item) => getFormattedLabel(item)) ?? [])]}
            isLoading={loadingInstitutions}
            isRequired
            pagination={paginationInstitutions}
            getOptions={(filters) => reqApiInstitutions('get', { params: { ...filters } })}
            placeholder={institution?.placeholder}
            control={control}
            errors={errors}
          />
        </Box>
        {watch('institution')?.value &&
          watch('institution')?.value !== 'TODAS' &&
          watch('institution') && (
            <Box flex={1}>
              <SelectInputForm
                name={team?.name}
                label={team?.label}
                options={[...(optionsTeams?.map((item) => getFormattedLabel(item)) ?? [])]}
                isLoading={loadingTeams}
                pagination={paginationTeams}
                getOptions={(filters) =>
                  reqApiTeams(
                    'get',
                    { params: { ...filters } },
                    `/v1/admin/teams?institution_id=${watch('institution').value}`
                  )
                }
                placeholder={team?.placeholder}
                control={control}
                errors={errors}
              />
            </Box>
          )}
        <Flex gap={5}>
          <Box flex={1}>
            <InputForm
              name={teacher?.name}
              label={teacher?.label}
              placeholder={teacher?.placeholder}
              isDisabled
              register={register}
              errors={errors}
            />
          </Box>
          <Box flex={1}>
            <InputForm
              name={classStudent?.name}
              label={classStudent?.label}
              placeholder={classStudent?.placeholder}
              isDisabled
              register={register}
              errors={errors}
            />
          </Box>
        </Flex>

        <Box flex={1}>
          <CustomParentsInputForm
            name={parents?.name}
            label={parents?.label}
            optionsKinship={optionsKinship}
            setFormValue={setValue}
            register={register}
            control={control}
            watch={watch}
            errors={errors}
          />
        </Box>

        <Flex mr="auto">
          <FormButton
            mt={4}
            w="100px"
            isLoading={isSubmitting}
            type="submit"
            textTransform="uppercase"
          >
            Salvar
          </FormButton>
        </Flex>
      </form>
    </FormBox>
  );
}
